/* src/app/app.component.scss */
main {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  font-family: "Noto Sans", sans-serif;
  overflow: hidden;
}
site-header {
  flex-shrink: 0;
  width: 100%;
  z-index: 1000;
}
.outlet {
  flex: 1 1 0%;
  overflow-y: auto;
  min-height: 0;
  max-height: calc(100vh - 135px - 97px);
}
site-footer {
  flex-shrink: 0;
  width: 100%;
  z-index: 500;
}
/*# sourceMappingURL=app.component-P7B4EAYB.css.map */
